<template>
  <div>
    <ModalAddVue title="إدارة التصنيفات" @closeModal="closeModal()">
      <template #body>
        <div class="categories-list">
          <div
            v-for="category in all_categories"
            :key="category.id"
            class="category-row"
            :class="{ archived: category.is_archived == 1 }"
          >
            <template v-if="editingId === category.id">
              <input
                type="text"
                v-model="editingName"
                class="category-name-input"
                maxlength="100"
                @keyup.enter="saveCategory(category)"
              />
              <div class="row-actions">
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="cursor-pointer stroke-current text-success"
                  @click.stop="saveCategory(category)"
                />
                <feather-icon
                  icon="XIcon"
                  svgClasses="cursor-pointer stroke-current text-danger"
                  @click.stop="cancelEditing()"
                />
              </div>
            </template>
            <template v-else>
              <span class="category-name">
                {{ category.name }}
                <span v-if="category.is_archived == 1" class="badge-archived">معطّل</span>
              </span>
              <div class="row-actions">
                <feather-icon
                  v-if="category.is_archived != 1"
                  icon="EditIcon"
                  svgClasses="cursor-pointer stroke-current"
                  @click.stop="startEditing(category)"
                />
                <feather-icon
                  v-if="category.is_archived == 1"
                  icon="RefreshCwIcon"
                  svgClasses="cursor-pointer stroke-current text-success"
                  @click.stop="toggleCategoryArchive(category)"
                />
                <feather-icon
                  v-else
                  icon="Trash2Icon"
                  svgClasses="cursor-pointer stroke-current text-danger"
                  @click.stop="toggleCategoryArchive(category)"
                />
              </div>
            </template>
          </div>
          <p v-if="!all_categories.length" class="empty-state">
            لا يوجد تصنيفات مضافة
          </p>
        </div>
      </template>
      <template #footer>
        <button class="second-btn" @click="closeModal()">إغلاق</button>
      </template>
    </ModalAddVue>
  </div>
</template>

<script>
import ModalAddVue from "../../layouts/components/ModalAdd.vue";
import { mapActions, mapGetters } from "vuex";
import notifyState from "../../mixins/notifyState";
export default {
  mixins: [notifyState],
  components: {
    ModalAddVue,
  },
  data() {
    return {
      editingId: null,
      editingName: "",
    };
  },
  computed: {
    ...mapGetters("products", ["error_msg", "success", "all_categories"]),
  },
  methods: {
    ...mapActions("products", ["fetchCategories", "updateCategory"]),
    closeModal() {
      this.$emit("closeModal");
    },
    startEditing(category) {
      this.editingId = category.id;
      this.editingName = category.name;
    },
    cancelEditing() {
      this.editingId = null;
      this.editingName = "";
    },
    async saveCategory(category) {
      if (!this.editingName || this.editingName.trim().length < 2) {
        return;
      }
      await this.updateCategory({ id: category.id, name: this.editingName.trim() });
      if (this.success === 1) {
        this.notifySuccess("editToast");
        this.cancelEditing();
        await this.fetchCategories({ all: true });
        await this.fetchCategories();
      } else {
        this.notifyFaild("faildEdit", this.error_msg);
      }
    },
    async toggleCategoryArchive(category) {
      await this.updateCategory({
        id: category.id,
        is_archived: category.is_archived == 1 ? 0 : 1,
      });
      if (this.success === 1) {
        this.notifySuccess("editToast");
        await this.fetchCategories({ all: true });
        await this.fetchCategories();
      } else {
        this.notifyFaild("faildEdit", this.error_msg);
      }
    },
  },
  async created() {
    await this.fetchCategories({ all: true });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";

.categories-list {
  max-height: 320px;
  overflow-y: auto;
  padding-inline-end: 4px;
}

.category-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 8px;
  background-color: #fff;
  transition: 0.2s;

  &:hover {
    border-color: $mainColor1;
  }

  &.archived {
    background-color: #f7f7f7;
    opacity: 0.7;
  }
}

.category-name {
  font-size: 15px;
  font-weight: 600;
  color: $mainColor1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.badge-archived {
  font-size: 11px;
  font-weight: 700;
  color: #ea5455;
  background-color: rgba(234, 84, 85, 0.12);
  border-radius: 10px;
  padding: 2px 8px;
}

.category-name-input {
  flex: 1;
  outline: none;
  border: 1px solid $mainColor1;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 15px;
  font-weight: 600;
  color: $mainColor1;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.empty-state {
  font-size: 13px;
  color: #999;
  text-align: center;
  padding: 12px 0;
}
</style>
